import { ReactNode } from 'react'; // ReactNode type is TS-only, so remove in JS
import { UserAuth } from '../context/AuthContext';
import { Navigate } from 'react-router-dom'; // typically react-router-dom, not 'react-router'
import { Center, Spinner } from '@chakra-ui/react';

const PrivateRoute = ({ children }) => {
  const { session } = UserAuth();

  if (session === undefined) {
    // Show Chakra UI spinner centered vertically and horizontally while loading
    return (
      <Center h="100vh">
        <Spinner size="xl" />
      </Center>
    );
  }

  return <>{session ? children : <Navigate to="/signup" />}</>;
};

export default PrivateRoute;
